export default __webpack_public_path__ + "static/media/3D.e077b799.svg";